<template>
  <v-dialog v-model="dialog" persistent width="980px">
    <v-card>
      <v-card-title class="headline m-0">
        <v-icon>check</v-icon> Aprobar permiso RRHH
        <v-spacer></v-spacer>
        <v-btn icon @click="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="py-0 px-4">
        <v-container grid-list-md class="p-0" style="min-width: 100%;">
          <v-layout row wrap>
            <v-flex xs12>
              <span class="subtitulo-aprobar">
                <b>Número:</b> {{ permiso.numero }}
              </span>
            </v-flex>
            <v-flex xs12>
              <span class="subtitulo-aprobar">
                <b>Funcionario:</b> {{ permiso.nombres }}
              </span>
            </v-flex>
            <v-flex xs12>
              <span class="subtitulo-aprobar">
                <b>Tipo de papeleta:</b> {{ permiso.tipo_permiso }}
              </span>
            </v-flex>
            <v-flex xs12 v-if="permiso.id_tipo_permiso == 5">
              <span class="subtitulo-aprobar">
                <b>
                  {{ permiso.id_parametro_permiso ? tipo_capacitacion : "" }}
                </b>
              </span>
            </v-flex>
            <v-flex xs12 v-if="permiso.permiso.id_tipo_permiso == '87'">
              <span class="subtitulo-aprobar">
                <b>Lugar de comisión :</b> {{ permiso.permiso.lugar }}
              </span>
            </v-flex>
            <v-flex
              xs12
              v-if="
                permiso.permiso.id_tipo_permiso == '87' ||
                  permiso.permiso.id_tipo_permiso == '96' ||
                  permiso.permiso.id_tipo_permiso == '101'
              "
            >
              <span class="subtitulo-aprobar">
                <b>Motivo:</b> {{ permiso.permiso.motivo }}
              </span>
            </v-flex>
            <v-flex xs12 v-if="permiso.permiso.id_tipo_permiso == '90'">
              <span class="subtitulo-aprobar">
                <b>Tipo de baja:</b> {{ permiso.permiso.motivo }}
              </span>
            </v-flex>
            <v-flex xs12 v-if="permiso.permiso.id_tipo_permiso == '61'">
              <span class="subtitulo-aprobar">
                <b>Fecha de nacimiento:</b>
                {{ permiso.fecha_nac_muerte }}
              </span>
            </v-flex>
            <v-flex xs12 v-if="permiso.permiso.id_tipo_permiso == '61'">
              <span class="subtitulo-aprobar">
                <b>Hora de nacimiento:</b>
                {{ permiso.hora_nac_muerte }}
              </span>
            </v-flex>
            <v-flex xs12 v-if="permiso.permiso.id_tipo_permiso == '6'">
              <span class="subtitulo-aprobar">
                <b>Fecha de fallecimiento:</b>
                {{ permiso.fecha_nac_muerte }}
              </span>
            </v-flex>
            <v-flex xs12 v-if="permiso.permiso.id_tipo_permiso == '6'">
              <span class="subtitulo-aprobar">
                <b>Hora de fallecimiento:</b>
                {{ permiso.hora_nac_muerte }}
              </span>
            </v-flex>
            <v-flex xs12 v-if="permiso.permiso.id_tipo_permiso == '12'">
              <span class="subtitulo-aprobar">
                <b>Fecha de matrimonio:</b>
                {{ $moment(permiso.fecha_nac_muerte).format("DD-MM-YY") }}
              </span>
            </v-flex>
            <v-flex xs12 v-if="permiso.permiso.id_tipo_permiso == '44'">
              <span class="subtitulo-aprobar">
                <b>Condición o estado crítico de salud:</b>
                {{ permiso.permiso.motivo }}
              </span>
            </v-flex>
          </v-layout>
          <span class="titulo-aprobar"><b>Detalles de papeleta</b></span>
          <!-- permisos justificativo caja nro 8 -->
          <v-layout v-if="permiso.id_tipo_permiso == 8">
            <v-flex xs12>
              <v-data-table
                :items="permiso_detalles2"
                class="tabla-comprimida-light elevation-1"
                hide-actions
                :headers="headers_caja"
              >
                <template v-slot:items="props">
                  <td class="text-xs-center">
                    {{ props.item.fecha_salida }}
                  </td>
                  <td class="text-xs-center">
                    {{ props.item.fecha_hasta }}
                  </td>
                  <td class="text-xs-center">
                    {{
                      $moment(props.item.hora_desde, "HH:mm")
                        .subtract("00:20")
                        .format("HH:mm")
                    }}
                  </td>
                  <td class="text-xs-center">{{ props.item.hora_desde }}</td>

                  <td class="text-xs-center">{{ props.item.hora_hasta }}</td>
                  <td class="text-xs-center">
                    {{
                      $moment(props.item.hora_hasta, "HH:mm")
                        .add("00:20")
                        .format("HH:mm")
                    }}
                  </td>
                  <td class="text-xs-center">
                    {{
                      $moment(props.item.total_horas, "HH:mm").format("HH:mm")
                    }}
                  </td>
                  <td
                    v-if="permiso.id_tipo_permiso == 24"
                    class="text-xs-center"
                  >
                    {{ props.item.total_dias }}
                  </td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex
              xs12
              v-if="
                permiso.id_tipo_permiso == 87 ||
                  permiso.id_tipo_permiso == 96 ||
                  permiso.id_tipo_permiso == 88 ||
                  (permiso.id_tipo_permiso >= 37 &&
                    permiso.id_tipo_permiso <= 43)
              "
            >
              <!-- permisos por horas -->
              <v-data-table
                :items="permiso_detalles2"
                class="tabla-comprimida-light elevation-1"
                hide-actions
                :headers="headers_horas"
              >
                <template v-slot:items="props">
                  <td class="text-xs-center">
                    {{ props.item.fecha_salida }}
                  </td>
                  <td class="text-xs-center">
                    {{ props.item.fecha_hasta }}
                  </td>

                  <td class="text-xs-center">{{ props.item.hora_desde }}</td>
                  <td class="text-xs-center">{{ props.item.hora_hasta }}</td>

                  <td class="text-xs-center">
                    {{
                      $moment(props.item.total_horas, "HH:mm").format("HH:mm")
                    }}
                  </td>
                </template>
              </v-data-table>
            </v-flex>
            <!-- permisos por dias decimales -->
            <v-flex
              xs12
              v-if="
                permiso.id_tipo_permiso == 14 ||
                  (permiso.id_tipo_permiso >= 98 &&
                    permiso.id_tipo_permiso <= 101) ||
                  permiso.id_tipo_permiso == 89 ||
                  permiso.id_tipo_permiso == 18
              "
            >
              <v-data-table
                :items="permiso_detalles2"
                class="tabla-comprimida-light elevation-1"
                hide-actions
                :headers="headers_dias_decimales"
              >
                <template v-slot:items="props">
                  <td class="text-xs-center">
                    {{ props.item.fecha_salida }}
                  </td>
                  <td class="text-xs-center">
                    {{ props.item.fecha_hasta }}
                  </td>
                  <td class="text-xs-center">
                    {{ props.item.hora_desde }}
                  </td>
                  <td class="text-xs-center">
                    {{ props.item.hora_hasta }}
                  </td>
                  <td class="text-xs-center">
                    {{ props.item.total_dias }}
                  </td>
                </template>
              </v-data-table>
            </v-flex>
            <!-- permisos por dias completos-->
            <v-flex
              xs12
              v-if="
                [6, 44, 95, 61, 12, 90, 5].includes(
                  parseInt(permiso.id_tipo_permiso)
                )
              "
            >
              <v-data-table
                :items="permiso_detalles2"
                class="tabla-comprimida-light elevation-1"
                hide-actions
                :headers="headers_dias"
              >
                <template v-slot:items="props">
                  <td class="text-xs-center">
                    {{ props.item.fecha_salida }}
                  </td>
                  <td class="text-xs-center">
                    {{ props.item.fecha_hasta }}
                  </td>
                  <td class="text-xs-center">
                    {{ props.item.total_dias }}
                  </td>
                </template>
              </v-data-table>
            </v-flex>
            <!-- permisos 94 formulario de registro de asistencias-->

            <v-flex xs12 v-if="permiso.id_tipo_permiso == 94">
              <v-data-table
                :items="permiso_detalles2"
                class="tabla-comprimida-light elevation-1"
                hide-actions
                :headers="headers_registro_asistencias"
              >
                <template v-slot:items="props">
                  <td class="text-xs-center">
                    {{ props.item.fecha_salida }}
                  </td>
                  <td class="text-xs-center">
                    {{ props.item.fecha_hasta }}
                  </td>
                  <td class="text-xs-center">
                    {{ props.item.hora_desde }}
                  </td>
                  <td class="text-xs-center">
                    {{ props.item.hora_hasta }}
                  </td>
                </template>
              </v-data-table>
            </v-flex>
            <v-flex xs12>
              <!-- permiso nro 24 -->
              <v-data-table
                :items="permiso_detalles"
                class="tabla-comprimida-light elevation-1"
                hide-actions
                :headers="headers"
                v-if="permiso.permiso.id_tipo_permiso == '24'"
              >
                <template v-slot:items="props">
                  <td
                    class="text-xs-center"
                    v-if="permiso.permiso.id_tipo_permiso == '24'"
                  >
                    {{ props.item.fecha_desde }}
                  </td>
                  <td
                    class="text-xs-center"
                    v-if="permiso.permiso.id_tipo_permiso == '24'"
                  >
                    {{ props.item.fecha_hasta }}
                  </td>

                  <td class="text-xs-center">{{ props.item.hora_desde }}</td>
                  <td class="text-xs-center">{{ props.item.hora_hasta }}</td>
                  <td class="text-xs-center">{{ props.item.total_dias }}</td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
          <v-layout
            v-if="permiso.tipo_permiso == 'PERMISO A CUENTA DE VACACIÓN'"
          >
            <v-flex xs12>
              <h4>
                <b>Total horas: {{ horas_solicitadas.toFixed(2) }}</b>
              </h4>
            </v-flex>
          </v-layout>
          <v-layout
            row
            wrap
            v-if="
              permiso.id_tipo_permiso == 88 || permiso.id_tipo_permiso == 96
            "
          >
            <h3>
              <b>Detalles compensacion</b>
            </h3>
            <v-flex xs12>
              <v-data-table
                :items="permiso_compensacion"
                class="tabla-comprimida-light elevation-1"
                hide-actions
                :headers="headers2"
              >
                <template v-slot:items="props">
                  <td class="text-xs-center">
                    {{ $moment(props.item.fecha_desde).format("DD/MM/YYYY") }}
                  </td>
                  <td class="text-xs-center">
                    {{ $moment(props.item.fecha_hasta).format("DD/MM/YYYY") }}
                  </td>
                  <td class="text-xs-center">{{ props.item.hora_desde }}</td>
                  <td class="text-xs-center">{{ props.item.hora_hasta }}</td>
                  <td class="text-xs-center">
                    {{ props.item.diferencia_horas }}
                  </td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
          <v-layout
            class="pa-2"
            v-if="
              permiso.id_tipo_permiso == 88 || permiso.id_tipo_permiso == 96
            "
          >
            <v-flex xs12>
              <h4>
                <b>Total horas: {{ total_horas_acomuladas }}</b>
              </h4>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <span class="titulo-aprobar"><b>Seguimiento de papeleta</b></span>
            <v-flex xs12>
              <v-data-table
                class="tabla-comprimida-light elevation-1"
                :items="detalle_seguimiento"
                hide-actions
                :headers="headers_detalle"
              >
                <template v-slot:items="props">
                  <td class="text-xs-center">
                    {{ props.item.fecha_registro }}
                  </td>
                  <td class="text-xs-center">{{ props.item.estado }}</td>
                  <td class="text-xs-center">{{ props.item.usuario }}</td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions class="px-4">
        <v-spacer></v-spacer>
        <v-btn color="error" type="submit" @click.prevent="close()"
          ><v-icon>clear</v-icon>
          Cerrar
        </v-btn>
        <v-btn
          color="success"
          @click.prevent="apruebaPermiso()"
          :loading="loading"
          ><v-icon>check</v-icon>
          Aprobar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate";
import SeguimientoDetalle from "../components/SeguimientoDetalle";

export default {
  components: {
    SeguimientoDetalle
  },
  mixins: [validate],
  props: ["item"],
  mounted() {
    this.$bus.$on("openDialogAprobarRRHHSinPermisos", async item => {
      this.permiso = item;

      (this.permiso_detalles2 = [
        {
          fecha_salida: this.permiso.fecha_desde,
          fecha_hasta: this.permiso.fecha_retorno,
          hora_desde: this.permiso.hora_desde,
          hora_hasta: this.permiso.hora_hasta,
          total_horas: this.permiso.horas_permiso,
          total_dias: this.permiso.nro_dias
        }
      ]),
        this.total_horas();
      await this.getDetallePermiso(item.id_permiso);
      this.verPermisosCompensacion(item.id_permiso);
      this.getDetalleSeguimiemto(item.id_permiso);
      // Buscamos tipo participacion censo
      if (this.permiso.id_tipo_permiso == 5) {
        this.tipo_capacitacion = await this.obtenerAgenteCapacitacion(
          this.permiso.id_parametro_permiso
        );
      }
      this.dialog = true;
    });
  },
  data() {
    return {
      usuario: this.$storage.get("user"),
      dialog: false,
      total_horas_acomuladas: 0,
      permiso: {
        permiso: {
          motivo: ""
        }
      },
      permiso_compensacion: [],
      permiso_detalles: [],
      permiso_detalles2: [],
      permiso_detalle: [],
      motivo2: [],
      vDetallePermisos: {},

      loading: false,
      headers: [
        {
          text: "Fecha salida",
          sortable: false,
          align: "center"
        },
        {
          text: "Fecha hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora desde",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora hasta",
          sortable: false,
          align: "center"
        },
        // {
        //   text: "Rango Horas",
        //   sortable: false,
        //   align: "center"
        // },
        {
          text: "Total Dias",
          sortable: false,
          align: "center"
        }
      ],
      headers_caja: [
        {
          text: "Fecha salida",
          sortable: false,
          align: "center"
        },
        {
          text: "Fecha hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "tolerancia",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora desde",
          sortable: false,
          align: "center"
        },

        {
          text: "Hora hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Tolerancia hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Total Horas",
          sortable: false,
          align: "center"
        }
      ],
      headers_dias_decimales: [
        {
          text: "Fecha salida",
          sortable: false,
          align: "center"
        },
        {
          text: "Fecha hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora desde",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora hasta",
          sortable: false,
          align: "center"
        },

        {
          text: "Total Dias",
          sortable: false,
          align: "center"
        }
      ],
      headers_horas: [
        {
          text: "Fecha salida",
          sortable: false,
          align: "center"
        },
        {
          text: "Fecha hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora desde",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Total Horas",
          sortable: false,
          align: "center"
        }
      ],
      headers_dias: [
        {
          text: "Fecha salida",
          sortable: false,
          align: "center"
        },
        {
          text: "Fecha hasta",
          sortable: false,
          align: "center"
        },
        // {
        // 	text: 'Hora desde',
        // 	sortable: false,
        // 	align: 'center'
        // },
        // {
        // 	text: 'Hora hasta',
        // 	sortable: false,
        // 	align: 'center'
        // },
        {
          text: "Total Dias",
          sortable: false,
          align: "center"
        }
      ],
      headers_registro_asistencias: [
        {
          text: "Fecha salida",
          sortable: false,
          align: "center"
        },
        {
          text: "Fecha hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora desde",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora hasta",
          sortable: false,
          align: "center"
        }
      ],
      headers2: [
        {
          text: "Fecha desde",
          sortable: false,
          align: "center"
        },
        {
          text: "Fecha hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora desde",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Total Horas",
          sortable: false,
          align: "center"
        }
      ],
      horas_solicitadas: 0,
      horas_solicitadas_comp: 0,
      detalle_seguimiento: [],
      headers_detalle: [
        {
          text: "Fecha registro",
          sortable: false,
          align: "center"
        },
        {
          text: "Estado",
          sortable: false,
          align: "center"
        },
        {
          text: "Usuario",
          sortable: false,
          align: "center"
        }
      ],
      // Variable censo
      tipo_capacitacion: {}
    };
  },
  methods: {
    // Metodo para obtener tipos de capacitacion censo
    async obtenerAgenteCapacitacion(id_parametro) {
      try {
        let res = await this.$service.graphql({
          query: `
            query{
              param(id:${id_parametro}){
                valor
              }
            }
          `
        });
        return res.param.valor;
      } catch (error) {
        console.log(error);
      }
    },
    // Envia correo al detinatario del permiso
    async enviarCorreoDestinatario(permiso) {
      let destinatario = await this.$service.obtieneDestinatarioPermiso(
        permiso.id_permiso
      );
      if (!destinatario) {
        return;
      }
      destinatario = JSON.parse(destinatario);
      var mensaje = `
            <h1>NOTIFICACIÓN APROBACIÓN DE PERMISO</h1>
            Estimado(a): ${destinatario.nombres}<br>El motivo de la presente es para informarle que se le APROBO un permiso con los siguientes datos:<br>
            <b>NOMBRE SOLICITANTE:</b>  <br>${permiso.nombres}<br>
            <b>TIPO DE PERMISO:</b>  <br>${permiso.tipo_permiso}<br>
            <b>NRO PAPELETA:</b>  <br>${permiso.numero}<br>
            <b>FECHA DE SOLICITUD:</b>  <br>${permiso.fecha_emision}<br>
            <b>FECHA SALIDA - FIN:</b>  <br>${permiso.fecha_desde} - ${permiso.fecha_retorno}<br>
            <b>HORAS:</b>  <br>${permiso.hora_desde} - ${permiso.hora_hasta}<br>
            <br>
            Saludos cordiales.`;
      await this.$service.sendEmail({
        correo: destinatario.correo,
        asunto: "NOTIFICACIÓN APROBACIÓN DE PERMISO",
        mensaje: mensaje.replace(/<[^>]+>/g, ""),
        html: mensaje
      });
    },
    async total_horas() {
      try {
        let respuesta = await this.$service.graphql({
          query: `
                query{
                  runQuery(consulta:"select control.fn_total_horas_compensacion(${this.permiso.id_permiso})"){
                    respuesta
                  }
                }	

              `
        });
        if (
          respuesta.runQuery.respuesta[0].fn_total_horas_compensacion == null ||
          respuesta.runQuery.respuesta[0].fn_total_horas_compensacion ==
            undefined
        ) {
          this.total_horas_acomuladas = 0;
        } else {
        }
        let resp = respuesta.runQuery.respuesta[0].fn_total_horas_compensacion;
        this.total_horas_acomuladas = resp;
      } catch (error) {
        console.log(error);
      }
    },
    close() {
      this.dialog = false;

      this.permiso = {
        permiso: {
          motivo: ""
        }
      };
      this.$bus.$emit("closeDialogAprobarRRHHSinRestriccion");
    },

    async apruebaPermiso() {
      const user = this.$storage.get("user");
      let fecha_actual = this.$moment(new Date()).format("YYYY/MM/DD");
      const permiso_copia = JSON.parse(JSON.stringify(this.permiso));
      let respuesta = "";
      try {
        respuesta = await this.$service.graphql({
          query: `
								query{
								runQuery(consulta:"select control.fn_aprueba_permiso_general(${parseInt(
                  this.permiso.id_permiso
                )},77,${this.permiso.id_persona},'${user.id}')"){
									respuesta
								}
								}
							`
        });

        let resp = respuesta.runQuery.respuesta[0].fn_aprueba_permiso_general;
        let resps2 = resp.split("|");

        let correcto = resps2[0];
        if (correcto == "1") {
          this.$message.success("El permiso fué aprobado");
          this.close();
        } else {
          this.$message.error(resps2[1]);
          this.close();
        }
        // ENVIO DE CORREO
        await this.enviarCorreoDestinatario(permiso_copia);
      } catch (error) {
        console.log(error);
      }
    },
    async getDetalleSeguimiemto(id) {
      try {
        let respuesta;
        let res;
        respuesta = await this.$service.graphql({
          query: `
                               query{
                                    runQuery(consulta:"SELECT * FROM control.v_seguimiento_detalle_historico vd where vd.id=(${id}) order by vd.id_seguimiento desc"){
                                  respuesta
                                }
                            }
                            `
        });

        respuesta = respuesta.runQuery.respuesta;
        //obtener el nuevo seguimiento
        res = await this.$service.graphql({
          query: `
                query{
      			      vSeguimientoDetalles(id:${id}){
          			    rows{
						          fecha_registro
            			    estado
            			    usuario
                      jefe
                      id_estado
                      motivo
                      jefe
                      }
                  }
              }

          `
        });
        res = res.vSeguimientoDetalles.rows;
        this.detalle_seguimiento = res.concat(respuesta);
      } catch (error) {
        console.log(error);
      }
    },
    async verPermisosCompensacion(id_permiso) {
      try {
        let respuesta = await this.$service.graphql({
          query: `
                               query{
                                    runQuery(consulta:"select * from control.fn_permiso_compensa_datos(${id_permiso}) AS datos"){
                                  respuesta
                                }
                            }
                            `
        });

        this.permiso_compensacion = respuesta.runQuery.respuesta;

        this.sumar_horas_compensa(this.permiso_compensacion);
      } catch (error) {
        console.log(error);
      }
    },
    async getDetallePermiso(id) {
      try {
        let res = await this.$service.graphql({
          query: `
			query{
					vDetallePermisos(id_permiso: ${id}){
					rows{
						id
						id_permiso
						fecha_desde
						fecha_hasta
						hora_desde
						hora_hasta
						total_dias
						total_horas
						estado_detalle
						rango_horario
					}
					}
				}
          `
        });
        this.permiso_detalles = res.vDetallePermisos.rows;

        this.sumar_horas(this.permiso_detalles);
      } catch (error) {
        console.log(error);
      }
    },

    aprobarRechazar(id_permiso, id_estado) {
      this.loading = true;
      this.$service
        .graphql({
          query: `
					query {
						apruebaControlPermiso(id_tipo_permiso: ${id_permiso}, id_estado: ${id_estado}, id_jefe: ${this.getUserId()}){
							mensaje
						}
					}
				`
        })
        .then(response => {
          if (response.apruebaControlPermiso.mensaje === "ok") {
            this.$message.success();
            this.$bus.$emit("closeDialog");
            this.close();
          } else {
            this.$message.error(response.apruebaControlPermiso.mensaje);
            this.close;
          }
        });
      this.loading = false;
    },
    sumar_horas(permiso_detalles) {
      if (this.permiso.id_tipo_permiso != 90) {
        let total = 0;
        permiso_detalles.forEach(item => {
          total +=
            this.$moment(item.fecha_hasta + " " + item.hora_hasta).diff(
              item.fecha_desde + " " + item.hora_desde,
              "minutes"
            ) / 60;
        });
        this.horas_solicitadas = total;
      }
    },
    sumar_horas_compensa(permiso_detalles) {
      if (this.permiso.id_tipo_permiso != 90) {
        let total_comp = 0;
        permiso_detalles.forEach(item => {
          total_comp +=
            this.$moment(item.fecha_hasta + " " + item.hora_hasta).diff(
              item.fecha_desde + " " + item.hora_desde,
              "minutes"
            ) / 60;
        });
        this.horas_solicitadas_comp = total_comp;
      }
    },

    getUserId() {
      const user = this.$storage.get("user");
      return user.id_persona;
    }
  }
};
</script>
<style lang="scss" scoped>
.titulo-aprobar {
  font-size: 1.5rem;
  color: rgb(24, 77, 121);
  font-weight: bold;
}
.subtitulo-aprobar {
  font-size: 1.3rem;
  color: rgb(24, 106, 121);
}
</style>



// WEBPACK FOOTER //
// src/components/admin/permiso/dialogs/AprobarRRHHSinPermisos.vue